
import * as defaultImport from "@splunk/react-ui/Switch";
export * from "@splunk/react-ui/Switch";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
